// extracted by mini-css-extract-plugin
export default {"container":"ErrorIcon_container__uFv5T","square":"ErrorIcon_square__mwAAB","iconContainer":"ErrorIcon_iconContainer__fKPjh"};